module.exports = __webpack_public_path__ + "img/icon18.dd697f3b.png";